import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ErrorNavigationService {
  private readonly storageKey = 'prev-error-url';
  private previousUrl: string | null = null;
  private redirectedToErrorPage = false;

  setPreviousUrl(url: string): void {
    this.previousUrl = url;
    sessionStorage.setItem(this.storageKey, url);
  }

  getPreviousUrl(): string | null {
    return this.previousUrl || sessionStorage.getItem(this.storageKey);
  }

  markRedirectToErrorPage(): void {
    this.redirectedToErrorPage = true;
  }

  wasRedirected(): boolean {
    return this.redirectedToErrorPage;
  }

  clear(): void {
    this.previousUrl = null;
    this.redirectedToErrorPage = false;
    sessionStorage.removeItem(this.storageKey);
  }
}
